import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M19 11h-3V9.5c0-1.05.45-1.5 1.5-1.5C19.14 8 20 6.24 20 4.5a.47.47 0 0 0-.15-.35c-.09-.1-.22-.15-.35-.15s-.26.05-.35.15a.47.47 0 0 0-.15.35c0 1.24-.52 2.5-1.5 2.5-1.59 0-2.5.91-2.5 2.5V11h-3c-1.1 0-2 .9-2 2v8.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V13c0-1.1-.9-2-2-2zm-8 2c0-.55.45-1 1-1h3v5h-4v-4zm9 8.5c0 2.49-2.01 4.5-4.5 4.5S11 23.99 11 21.5V18h9v3.5zm0-4.5h-4v-5h3c.55 0 1 .45 1 1v4z",
      clipRule: "evenodd",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  }));
};
export default SvgComponent;